import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { homeNode } from "motw_core/Repositories/WorkflowRepository";
import { GetAllVisibleNodesAsync } from "motw_core/Workflows/GetVisibleNodes";

export const GetImmediateChildrenAsync = async (
    rootNode: IWorkflowNode,
    allNodesCached?: IWorkflowNode[]
) => {
    const nodes = allNodesCached
        ? allNodesCached
        : await GetAllVisibleNodesAsync(rootNode);

    const immediateChildren = (nodes ?? []).filter(
        (node) =>
            node.parentid === rootNode.id &&
            node.id !== homeNode.id &&
            node.id !== rootNode.id
    );

    return immediateChildren;
};
